import React, { Suspense, lazy } from 'react';

const LazyShopifyPricingPlan = lazy(() => import('../../../containers/ShopifyPricingPlan/ShopifyPricingPlan'));

function ShopifyOnboardStep3() {

  return (
    <div className='shopify-onboard-step3-wrap'>
      <Suspense fallback={<div></div>}>
        <LazyShopifyPricingPlan />
      </Suspense>
    </div>
  );
}

export default ShopifyOnboardStep3;
